import type { WaitSoundVolume } from "@/types/ai-assistant-style";

/** Teks setelan bunyi tunggu napas (#60) di "Gaya & aturan Jenna". */
export interface AssistantWaitSoundText {
	title: string;
	description: string;
	enabled: string;
	volume: string;
	volumes: Record<WaitSoundVolume, string>;
}

const id: AssistantWaitSoundText = {
	title: "Bunyi tunggu (mode suara)",
	description:
		"Bunyi napas lembut saat jawaban belum siap beberapa saat. Berhenti begitu Jenna mulai bicara.",
	enabled: "Nyalakan bunyi tunggu",
	volume: "Volume",
	volumes: { pelan: "Pelan", sedang: "Sedang", keras: "Keras" },
};

const en: AssistantWaitSoundText = {
	title: "Waiting sound (voice mode)",
	description:
		"A soft breathing sound while the answer is not ready yet. It stops as soon as the assistant starts speaking.",
	enabled: "Enable waiting sound",
	volume: "Volume",
	volumes: { pelan: "Low", sedang: "Medium", keras: "High" },
};

export const assistantWaitSoundTexts = { id, en } as const;
